import React from 'react'

import Main from './Main'
import Footer from './Footer'

function Home() {
	return (
		<>
			<main id="main">
				<Main/>
				<Footer/>
      </main>
		</>
	)
}

export default Home